import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ActivityIncludedItem from './activity-included-item';
import ActivityIncludedItemDetail from './activity-included-item-detail';
import ActivityIncludedItemUpdate from './activity-included-item-update';
import ActivityIncludedItemDeleteDialog from './activity-included-item-delete-dialog';

const ActivityIncludedItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ActivityIncludedItem />} />
    <Route path="new" element={<ActivityIncludedItemUpdate />} />
    <Route path=":id">
      <Route index element={<ActivityIncludedItemDetail />} />
      <Route path="edit" element={<ActivityIncludedItemUpdate />} />
      <Route path="delete" element={<ActivityIncludedItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ActivityIncludedItemRoutes;
